import type {
  CompanyDetailResponse,
  ContactCountResponse,
  SimilarSitesAIResponse,
  DatapointsResponse,
} from '../entities/CompanyDetail'
import type { InjectionKey } from 'vue'

export interface ICompanyDetailService {
  getCompanyDetail(id: string, savedSearchId?: string): Promise<CompanyDetailResponse>
  getCompanyLogo(host: string): Promise<string>
  getContactCount(leadId: string, savedSearchId?: string): Promise<ContactCountResponse>
  getSimilarSitesAI(leadEncId: string, take?: number): Promise<SimilarSitesAIResponse>
  getDatapoints(): Promise<DatapointsResponse>
  logCopiedData(copiedValue: string, copiedType: string): Promise<void>
}

export const COMPANY_DETAIL_SERVICE_KEY: InjectionKey<ICompanyDetailService> =
  Symbol('ICompanyDetailService')
